/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Badge } from "reactstrap";
import { find_category } from "../../actions/Tenants/config/utils";

interface CategoryColorBadgeProps {
    value: number | string;
    categories: any[] | false;
}

export function CategoryColorBadge({ value, categories }: CategoryColorBadgeProps) {
    const category = find_category(value, categories);
    if (!category) {
        return <span>{value}</span>;
    }

    // * Use a nice badge if a color is defined
    if (category.color) {
        return <Badge css={css`background-color: ${category.color}!important`} className={`${category.className || "text-white"} me-1 rounded-pill px-2`} pill> {category.label || category.text} </Badge>;
    }
    return <span className={category.className}>{category.label || category.text }</span>;
}

interface QualityBadgeProps {
    quality: string;
}

// TODO: delete this
export function QualityBadge({ quality }: QualityBadgeProps) {
    if (quality !== "a" && quality !== "b") {
        return null;
    }

    const color = quality === "a" ? "success" : "danger";

    return <Badge color={color} className="rounded-pill text-white px-2 text-uppercase" pill> {quality} </Badge>;
}

interface LegacyDefectBadgesProps {
    defects: any[];
}
// TODO: refactor when we finally make a project of the fruit table refactoring. Now you can only choose to either show internal or external defects, but nothing with severerity
export function LegacyDefectBadges({ defects }: LegacyDefectBadgesProps) {
    if (defects.length === 0) {
        return (<span>-</span>);
    }

    return (
        <div css={css`max-width: 12rem;`}>
            {defects.map((defect) => (
                <Badge key={defect.defect_id} color="secondary" className="me-1 rounded-pill" pill>
                    {defect.label}
                </Badge>
            ))}
        </div>
    );
}

interface DefectBadgesProps {
    defects: string;
}
export function DefectBadges({ defects: defectsAsString }: DefectBadgesProps) {
    const defects = defectsAsString.split(",");
    if (defects.length === 0) {
        return (<span>-</span>);
    }

    return (
        <div css={css`max-width: 12rem;`}>
            {defects.map((defect, index) => (
                <Badge key={index} color="secondary" className="me-1 rounded-pill" pill>
                    {defect}
                </Badge>
            ))}
        </div>
    );
}
